import React from "react";

export default function Footer() {
  return (
    <footer className="Footer" id="Footer">
      <p>Build with ❤️ in New York City, circa 2022.</p>
    </footer>
  );
}
